export const InstallGuideContent = {
  title: 'Install RISE',

  // What is a PWA section
  whatIsPwa: {
    title: 'What is this?',
    description:
      "RISE is a Progressive Web App (PWA). Think of it like a regular app, but instead of downloading it from an app store, you install it directly from your browser. It works offline, loads fast, and you'll get a home screen icon just like any other app.",
    benefits: [
      'Works offline or with spotty connection',
      'Faster loading after first visit',
      'Home screen icon for quick access',
      'No app store required',
    ],
  },

  // Installation instructions by platform
  instructions: {
    ios: {
      title: 'iPhone',
      subtitle:
        'Ensure you are using iOS16.4 or higher for the best experience',
      steps: [
        {
          step: 1,
          title: 'Tap the Share button',
          description: 'Look for the square with an arrow pointing up',
        },
        {
          step: 2,
          title: 'Scroll down and tap "Add to Home Screen"',
          description:
            'You may need to scroll down in the share menu to find this option',
        },
        {
          step: 3,
          title: 'Tap "Add"',
          description:
            "You can rename the app if you'd like, then tap Add in the top right",
        },
      ],
      note: 'We recommend using a Chrome browser on iOS. Safari works, but be aware that some features may not work as expected until the app is installed.',
    },
    android: {
      title: 'Android',
      subtitle: 'Chrome Browser',
      steps: [
        {
          step: 1,
          title: 'Tap the menu button',
          description: 'Look for the three dots (⋮) in your browser',
        },
        {
          step: 2,
          title: 'Tap "Add to Home screen" or "Install app"',
          description:
            "Chrome may show either option depending on your device's version",
        },
        {
          step: 3,
          title: 'Confirm the installation',
          description: 'Tap "Install" or "Add" when prompted',
        },
      ],
      note: 'Works best in Chrome. Samsung Internet and other browsers may also support installation.',
    },
  },

  // Help section
  help: {
    title: "Don't see the install option?",
    tips: [
      "Make sure you're using a supported browser (Safari on iOS, Chrome on Android/Desktop)",
      'If you already installed the app, the option may not appear',
      'Try refreshing the page and waiting a few seconds',
      'Some browsers require you to visit a site multiple times before showing the install option',
    ],
  },

  // Already installed section
  alreadyInstalled: {
    title: 'Already installed?',
    description:
      "Look for the RISE icon on your home screen or in your applications. If you see it there, you're all set!",
  },
} as const;

